module.exports = __webpack_public_path__ + "img/celeb-icon.2e97a6b5.svg";